import type { SvgIconProps } from "@mui/material/SvgIcon";

import DuckLoadingSpinnerIcon from "features/ui/Icons/DuckLoadingSpinnerIcon";

const LoadingSpinner = (props: SvgIconProps) => (
  <div className="!animate-spin">
    <DuckLoadingSpinnerIcon {...props} size={20} />
  </div>
);

export default LoadingSpinner;
